import { render, staticRenderFns } from "./PopoverPosition.vue?vue&type=template&id=5cf6a765"
import script from "./PopoverPosition.vue?vue&type=script&lang=js"
export * from "./PopoverPosition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports